import { render, staticRenderFns } from "./ManufacturerProfile.vue?vue&type=template&id=4a08131e&scoped=true&"
import script from "./ManufacturerProfile.vue?vue&type=script&lang=js&"
export * from "./ManufacturerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08131e",
  null
  
)

export default component.exports